<div class="bg-intro pt-4 pb-4">
    <div class="d-flex text-center w-100 mb-4">
        <div class="w-25 mobile"></div>
        <div class="w-25 mobile-width analysis" (click)="changeData(1)"><span [ngClass]="{'text-under': i === 1}">Phân tích hình ảnh</span></div>
        <div class="w-25 mobile-width analysis" (click)="changeData(2)"><span [ngClass]="{'text-under': i === 2}">Phân tích Video</span></div>
        <div class="w-25 mobile"></div>
    </div>
    <app-slide-carousel *ngIf="i===1" [data]="data"></app-slide-carousel>
    <app-slide-carousel *ngIf="i===2" [data]="data"></app-slide-carousel>
</div>